<template>
	<div>
		<v-dialog
	content-class="dialog-loading"
	max-width="300"
    persistent
	v-model="dialogLoading">
		<label class="loading-search">
			Espere unos segundos porfavor
		</label>
		<v-progress-linear
			indeterminate
			color="white"
			class="mb-0"
		></v-progress-linear>
	</v-dialog>
	</div>
</template>
<script>
export default {
	name: 'progress-wait',
	model: {
		prop: 'dialogLoading',
	},
	props: {
		dialogLoading: {
			type: Boolean,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/progress-wait/progress-wait.vue